export enum StatisticsLabels {
  COMPLETED_SESSIONS = 'Održane sesije',
  FUTURE_SESSIONS = 'Zakazane sesije',
  PROFIT_BY_MONTH = 'Mjesečna zarada (BAM)',
}
